(function() {
    'use strict';

    angular
        .module('app')
        .directive('libraryPicker', librarypicker);

    librarypicker.$inject = ['libraryService', '$filter', '$window', '$timeout', '$rootScope', 'fileGuideService'];
    
    function librarypicker(libraryService, $filter, $window, $timeout, $rootScope, fileGuideService) {
        // Usage:
        //     <librarypicker></librarypicker>
        // Creates:
        // 
        var directive = {
            restrict: 'EA',
            scope: {
                csDisabled: '=?',
                schemaId: '=',
                nodeClick: '=',
                inputModel: '=',
                onSubmit: '=?',
                tabIndex: '=?',
                disableScroll: '=?',
                maxHeight: '=?',
                padding: '=?'
            },
            link: link,
            templateUrl: 'app/librarypicker/templates/librarypicker.html'
        }

        return directive;

        function link(scope, elem, attr) {
            scope.nodeSelected = false;
            scope.element = elem;
            scope.loading = false;
            scope.selectedNodeBackup = {};
            scope.showClear = false;
            scope.placeHolder = "Type to search library";
            scope.fileGuideService = fileGuideService;
            //to assign each node a unique id and improve performance in IE;
            scope.uniqueId = 0;

            if (scope.padding) {
                $(elem).find('.select-input').css('padding', scope.padding + 'px');
            }

            if (scope.height) {
                $(elem).find('.select-input').css('height', scope.height + 'px');
            }

            if (scope.maxHeight) {
                $(elem).find('.dropdown-content').css('max-height', scope.maxHeight + 'px');
            }


            var onNodeSelected = function (event, data) {
                scope.selectedNode = data;
                scope.$apply();
            }

            scope.tree = [];
            scope.treeCopy = [];

            //Method to clear the input box
            scope.clearSelected = function () {
                scope.selectedNode = {};
                scope.inputModel = "";
                scope.showClear = false;
                scope.tree = scope.treeCopy;

                //recording this as a node click to ensure the model in the controller gets updated.
                scope.nodeClick("", scope.schemaId);
            }

            //Called when the input box text changes, used for the live search of libraries
            scope.textChanged = function (query) {
                scope.nodeSelected = false;
                if (query == "") {
                    scope.showClear = false;
                }
                else {
                    scope.showClear = true;
                }
                scope.show = 'show';

                var prop = fileGuideService.showFolder ? "folder" : "name";

                scope.tree = $filter('cutTree')(scope.treeCopy, query, prop);
                scope.nodeClick(query, scope.schemaId);
            }

            //called when an item is clicked
            scope.itemClicked = function (item, doubleClicked) {
                if (!item.vaultType) {
                    unselectNodes(scope.tree);
                    unselectNodes(scope.treeCopy);
                    scope.nodeSelected = true;
                    item.selected = true;
                    scope.showClear = false;
                    var value = "";
                    //depending on field
                    switch (scope.schemaId) {
                        case "SCHEMA_S_LIBNAME":
                            value = item.name;
                            break;
                        case "SCHEMA_S_LIBPATH":
                            value = item.path;
                            break;
                        case "SCHEMA_S_FOLDER":
                            value = item.folder;
                            break;
                        default:
                            value = item.name;
                            break;
                    }

                    scope.inputModel = value;
                    scope.nodeClick(value, scope.schemaId, item);

                    if (doubleClicked) {
                        scope.show = false;
                    }
                }
                
            }

            //called when a node is expanded
            scope.expand = function (node) {
                node.expanded = true;
            }

            //close the dropdown
            scope.closeModal = function (cancel) {
                if (cancel) {
                    scope.selectedNode = scope.selectedNodeBackup;
                }
                scope.showModal = false;
                angular.element(backdrop).off('click', bdOnClick);
            }

            

            //toggle for the dropdown
            scope.showToggle = function () {
                //notify other dropdowns to close
                $rootScope.$broadcast('dropDownShown');
                if (!scope.csDisabled) {
                    if (scope.tree.length == 0) {
                        scope.loading = true;
                        libraryService.getTree().then(function (data) {
                            scope.loading = false;
                            var tree = angular.copy(data);
                            scope.treeCopy = angular.copy(tree);
                            scope.tree = tree;
                            checkScroll();
                        });
                    }
                    scope.selectedNodeBackup = {};
                    angular.copy(scope.selectedNode, scope.selectedNodeBackup);
                }
                scope.showList();
                checkScroll();
            }

            //when the input is focused
            scope.inputFocus = function () {
                scope.showClear = scope.inputModel ? true : false;
                if (scope.showClear) {
                    scope.showClear = scope.inputModel != "" ? true : false;
                } 
                scope.showToggle();
            }

            //shows the tree
            scope.showList = function () {
                var w = angular.element($window);
                w.bind('click', windowBind);
                if (scope.show != 'show') {
                    scope.show = 'show'
                }
                else {
                    scope.show = '';
                }
            }

            //when user leaves the input
            scope.inputBlur = function () {
                if (!scope.nodeSelected && !scope.show)
                    scope.clearSelected();
                //allows the x to clear to be clicked
                $timeout(function () {
                    if (!scope.show || scope.inputModel == "") {
                        scope.showClear = false;
                        scope.$apply();
                    }                      
                }, 100);              
            }

            scope.isVault = function (member) {
                
            }
        
            //bind click to close the library picker
            var windowBind = function (e) {
                try {
                    if (e.target.id != scope.schemaId) {

                        var el = $(e.target);
                        var isExpandOrCollapse = el.hasClass('fa-plus-square-o') || el.hasClass('fa-minus-square-o');

                        if (!$(e.target).closest('#' + scope.schemaId + 'dd').length && !isExpandOrCollapse) {
                            var w = angular.element($window);
                            w.off('click', windowBind);
                            scope.showClear = false;
                            scope.show = '';
                            scope.$apply();
                        }                  
                    }
                } catch (e) {

                }
            }

            scope.searchValue = "";

            scope.onKeyPress = function (e) {
                switch (e.keyCode) {
                    case 9:
                        scope.show = '';
                        break;
                    case 13:
                        scope.onSubmit();
                        break;
                    default:

                }
            }

            var checkScroll = function () {
                if (!scope.disableScroll) {
                    //on a timeout to allow the items to paint
                    $timeout(function () {
                        //get the position of the textbox relative to the card
                        var element = scope.element.parent();
                        var elementTopPosition = element.prop('offsetTop');
                        var container = element.parent();
                        var parentHeight = container.height();

                        //find the parent tab-controls
                        while (!container.hasClass('tab-controls')) {
                            container = container.parent();
                            //in case it isn't found
                            if (container.is('body')) {
                                break;
                            }
                        }

                        //if the element's position + 350 is greater than the height of the parent
                        //plus the scroll position then scroll needed
                        if (elementTopPosition + 300 > parentHeight + container.scrollTop()) {
                            container.scrollTop(container.scrollTop() + (elementTopPosition - (parentHeight + container.scrollTop())) + 300);
                        }
                    }, 200);
                }              
            }
        
        }
    
    }

    function unselectNodes(nodes) {
        angular.forEach(nodes, function (item, key) {
            item.selected = false;
            if (angular.isArray(item.children)) {
                unselectNodes(item.children);
            }
        });
    }

    function collapseNodes(nodes) {
        angular.forEach(nodes, function (item, key) {
            item.expanded = false;
            if (angular.isArray(item.children)) {
                collapseNodes(item.children);
            }
        })
    }

    angular.module('app').filter('cutTree', ['$filter', function ($filter) {
        return function (tree, query, prop) {
            var res = [];
            angular.forEach(tree, function (item) {
                // Deep copy
                var copy = angular.fromJson(angular.toJson(item));
                var finalProp = prop ? prop : "name";
                if (!copy[prop])
                    finalProp = "name";

                var hasWordStarts = anyWordStartsWith(copy[finalProp], query);

                if (copy.vaultType) {
                    var children = $filter('cutTree')(copy.children, query, prop);
                    if (children.length > 0) {
                        copy.children = children;
                        res.push(copy);
                    }                 
                }
                else {
                    if (!hasWordStarts) {
                        var children = $filter('cutTree')(copy.children, query, prop);
                        res = res.concat(children);
                    }
                    else {
                        var children = copy.children; //$filter('cutTree')(copy.children, query);
                        copy.children = children;

                        //item.expanded = true;
                        res.push(copy);
                    }
                }
            });
            if (query != "")
                return res.slice(0, 100);
            return res;
        }

        function anyWordStartsWith(term, searchTerm) {
            var startsWith = false;
            var searchTermArray = $filter('lowercase')(searchTerm).split(" ");
            var wordArray = $filter('lowercase')(term).split(" ");

            angular.forEach(searchTermArray, function (sTerm, key) {
                angular.forEach(wordArray, function (item, key) {
                    if (item.indexOf($filter('lowercase')(sTerm)) == 0) {
                        startsWith = true;
                    }
                    else {
                        return false;
                    }
                });
            });
            
            return startsWith
        }
    }]);

    

})();